import React from 'react';
import * as R from 'ramda';
import AdDetailsForm from './AdDetailsForm';
import UserContext, {User, userEmail} from '../common/UserContext';
import {AdRequestFormFields} from './AdDetailsForm';
import {handleResponse} from '../../ext/common/rest-api-helper';
import {useParams} from 'react-router';
import {AdRequestProffer, JsonAdDetail} from '../../ext/lib/types';

type Args = {key: string};

const EditAd: React.FC<Args> = () => {
  const {key} = useParams() as Args;
  const {user, apiToken} = React.useContext(UserContext);
  const [ad, setAd]: [JsonAdDetail|undefined, React.Dispatch<JsonAdDetail>] = React.useState();

  const userKey: (_: User|undefined) => string =
    R.pipe(userEmail, btoa);

  const loadAd: (_: User) => void =
    R.pipe(
      (user: User) =>
        fetch(`/api/v1/requests/${userKey(user)}/${key}`, {
          headers: {
            Authorization: apiToken || 'missing-token'
          }
        }),

      R.andThen(handleResponse as (_: Response) => Promise<JsonAdDetail>),
      R.andThen(R.unless(R.isNil, setAd)),
      R.otherwise(err =>
        console.error('Unable to load ad: %o', err))
    );

  // eslint-disable-next-line
  React.useEffect(() => {
    if (user) {
      loadAd(user);
    }
  }, [user, key]);

  const saveAd = R.pipe(
    JSON.stringify as (_: AdRequestFormFields) => string,
    ad =>
      fetch(`/api/v1/requests/${userKey(user)}/${key}`, {
        method: 'PATCH',
        headers: {
          'Authorization': apiToken || 'missing-token',
          'Content-Type': 'application/json'
        },
        body: ad
      }),
    R.andThen(handleResponse),
    R.andThen(R.path(['adKey']))
  );

  const handleSubmit: (_: AdRequestFormFields) => void =
    R.pipe(
      saveAd,
      R.andThen(R.tap(adKey =>
        console.info('Updated ad \'%s\'', adKey))),
      R.andThen(() =>
        window.history.back()),
      R.otherwise(err => {
        console.error('Unable to save ad: %o', err);
        alert('Unable to save your ad. Try again or contact support.');
      })
    );

  const render = R.ifElse(R.either(R.isNil, R.isEmpty),
    R.always(<div>loading...</div>),
    (ad: AdRequestProffer) =>
      <AdDetailsForm setAdDetails={handleSubmit} proffer={ad} />);

  // TODO: Revisit types in EditAd render. Maybe change to AdProffer, and address undefined possibility
  return render(ad as AdRequestProffer);
};
export default EditAd;
